import React from 'react';
import { ExamMetrics } from './exams-metrics';

export function ExamMetricsList() {
  return (
    <div className="main-content main-content--block">
      <ExamMetrics />
    </div>
  );
}
